import BaseLayout from "layouts/base-layout";

export default function NotFoundPage() {
  return (
    <BaseLayout>
      <h1 className="text-2xl text-gray-700">Page not found</h1>
    </BaseLayout>
  );
}
